import CryptoJS from "crypto-js";
import { responseEncrypted, secretKey } from "./cryptoConfig";
import { RoleTypesEnum } from "../Admin/Pages/RolesAndPermissions/rolesAndPermissionsTypes";

function modifySecretKey(key: any) {
  return CryptoJS.SHA256(key); // Derive a 256-bit key using SHA-256
}
export function encrypt(text: any) {
  let key = secretKey;
  const secretKey1 = modifySecretKey(key); // Derive the key
  const iv = CryptoJS.enc.Utf8.parse("678025308de70905");
  const encrypted = CryptoJS.AES.encrypt(text, secretKey1, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  }).toString();
  return encrypted;
}
/** Function to Decrypt the data */
export function decrypt(text: any) {
  if (!text) {
    return "";
  }
  try {
    let key = secretKey;
    const secretKey1 = modifySecretKey(key); // Derive the key
    const iv = CryptoJS.enc.Utf8.parse("678025308de70905"); // 16-byte IV
    const decrypted = CryptoJS.AES.decrypt(text, secretKey1, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedText;
  } catch (error) {
    console.error("Error decrypting text:", error);
    throw error;
  }
}
export let encryptByText = async (text: any) => {
  let a = text.split("");
  let ae = await Promise.all(
    a.map(async (v: any) => {
      let data = await encrypt(v);
      return data;
    }),
  );
  return ae.join(""); // Join with space or any delimiter
};

// export let decryptByText = (encryptedText: any) => {
//   try {
//     let encryptedComponents = encryptedText.split("=="); // Split by the same delimiter used in encryption
//     let decryptedComponents = encryptedComponents.map((comp: any) => {
//       let data = decrypt(comp + "==");
//       return data;
//     });
//     return decryptedComponents?.join("");
//   } catch (error) {
//     return "";
//   }
//   // Split the concatenated encrypted text back into its components
// };

const textDecryptionCache = new Map<string, string>();

export const decryptByText = (encryptedText: string) => {
  try {
    // 1. Safety Check
    if (!encryptedText || typeof encryptedText !== "string") return "";

    const cached = textDecryptionCache.get(encryptedText);
    if (cached !== undefined) return cached;

    // 2. Split and FILTER
    // The .filter(Boolean) removes the empty string "" at the end
    const chunks = encryptedText.split("==").filter(Boolean);

    // 3. Decrypt chunks
    const decryptedParts = chunks.map((chunk) => {
      // Re-add the delimiter that split() removed
      return decrypt(chunk + "==");
    });

    const result = decryptedParts.join("");
    // Limit cache size to 10000 entries to prevent memory leaks
    if (textDecryptionCache.size > 10000) {
      textDecryptionCache.clear();
    }
    textDecryptionCache.set(encryptedText, result);
    return result;
  } catch (error) {
    // If this hits, it means your Secret Key is likely wrong in .env
    console.error("decryptByText failed:", error);
    return "";
  }
};

export let responseDataFormate = (data: any) => {
  if (responseEncrypted == "1") {
    try {
      const decryptedData = decrypt(data);
      return JSON.parse(decryptedData);
    } catch (error) {
      console.error("Error formatting response data:", error);
      return null;
    }
  } else {
    return data;
  }
};

export let requestPayloadBodyFormate = (data: any) => {
  if (responseEncrypted == "1") {
    try {
      const newData = JSON.stringify(data);
      const result = encrypt(newData);

      return { data: result };
    } catch (error) {
      return null;
    }
  } else {
    return data;
  }
};

const STORAGE_KEY = "user_data";
const SECRET_KEY_FOR_USER = secretKey || ""; // 🔐 Use env variable in production

// Helper function to resolve active role from single role object or role array
export const getActiveRole = (roleData: any) => {
  if (!roleData) return null;

  if (Array.isArray(roleData)) {
    if (roleData.length === 0) return null;

    const savedDefaultRoleStr = localStorage.getItem("default_role");
    if (savedDefaultRoleStr) {
      try {
        const savedRole = JSON.parse(savedDefaultRoleStr);
        const matchedRole = roleData.find(
          (r: any) =>
            (r?._id && savedRole?._id && r._id === savedRole._id) ||
            (r?.key && savedRole?.key && r.key === savedRole.key),
        );
        if (matchedRole) {
          return matchedRole;
        }
      } catch (e) {
        console.error("Error parsing default_role from localStorage", e);
      }
    }

    const firstRole = roleData[0];
    if (firstRole) {
      try {
        localStorage.setItem("default_role", JSON.stringify(firstRole));
      } catch (e) {
        console.error("Error saving default_role to localStorage", e);
      }
    }
    return firstRole;
  }

  return roleData;
};

// Encrypt and store user data
export const setEncryptedUserData = (userData: any) => {
  try {
    const activeRole = getActiveRole(userData?.role);
    const updatedUserData = {
      ...userData,
      role: activeRole,
      roles: Array.isArray(userData?.role)
        ? userData.role
        : userData?.roles || (activeRole ? [activeRole] : []),
    };
    const jsonString = JSON.stringify(updatedUserData);
    const encrypted = CryptoJS.AES.encrypt(
      jsonString,
      SECRET_KEY_FOR_USER,
    ).toString();
    localStorage.setItem(STORAGE_KEY, encrypted);
  } catch (error) {
    console.error("Encryption error:", error);
  }
};

// Retrieve and decrypt user data
export const getDecryptedUserData = () => {
  try {
    const encrypted = localStorage.getItem(STORAGE_KEY);
    if (!encrypted) return null;

    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY_FOR_USER);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    const newData = JSON.parse(decrypted);
    const activeRole = getActiveRole(newData?.role);
    const descriptedNewData = {
      ...newData,
      email: newData?.email,
      full_role_details: activeRole,
      role: activeRole,
      roles: Array.isArray(newData?.role) ? newData.role : newData?.roles,
    };
    return descriptedNewData;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

const STORAGE_KEY_TOKEN = "permision_token";
const SECRET_KEY_FOR_TOKEN = secretKey || ""; // 🔐 Use env variable in production

export const setEncryptedToken = (token: any) => {
  try {
    const jsonString = token;
    const encrypted = CryptoJS.AES.encrypt(
      jsonString,
      SECRET_KEY_FOR_TOKEN,
    ).toString();
    localStorage.setItem(STORAGE_KEY_TOKEN, encrypted);
  } catch (error) {
    console.error("Encryption error:", error);
  }
};

export const getDecryptedToken = () => {
  try {
    const encrypted = localStorage.getItem(STORAGE_KEY_TOKEN);
    // console.log('encrypted',encrypted );
    if (!encrypted) return null;

    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY_FOR_TOKEN);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    // console.log('decrypted',decrypted,SECRET_KEY_FOR_TOKEN);
    return decrypted;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

const STORAGE_FCM_TOKEN = "fcm_token";
const SECRET_FCM_FOR_TOKEN = secretKey || ""; // 🔐 Use env variable in production

export const setFcmEncryptedToken = (token: any) => {
  try {
    const jsonString = token;
    const encrypted = CryptoJS.AES.encrypt(
      jsonString,
      SECRET_FCM_FOR_TOKEN,
    ).toString();
    localStorage.setItem(STORAGE_FCM_TOKEN, encrypted);
  } catch (error) {
    console.error("Encryption error:", error);
  }
};
export const getFcmDecryptedToken = () => {
  try {
    const encrypted = localStorage.getItem(STORAGE_FCM_TOKEN);
    if (!encrypted) return null;

    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_FCM_FOR_TOKEN);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    return decrypted;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

export const getDecryptedName = (userObj: any): string => {
  // 1. Handle Empty/Null
  if (!userObj) return "-";

  // Helper to capitalize first letter only (preserves "McDonald" casing if existing)
  // const capitalize = (str: string) => {
  //   if (!str) return "";
  //   return str.charAt(0).toUpperCase() + str.slice(1);
  // };

  // 2. Handle Object (The standard case: { first_name: "...", last_name: "..." })
  if (typeof userObj === "object") {
    // Decrypt then Capitalize
    const firstName = decryptByText(userObj.first_name || "");
    const lastName = decryptByText(userObj.last_name || "");

    // Combine, trim whitespace
    const fullName = `${firstName} ${lastName}`.trim();

    // If the result is empty string (decryption failed or empty data), return "-"
    return fullName || "-";
  }

  // 3. Handle String (Legacy data or plain text)
  return String(userObj);
};

/**
 * Checks if the currently logged-in user has the 'client' role.
 */
export const isClientLoggedIn = (): boolean => {
  const userData = getDecryptedUserData();

  // Safety check for null data or missing role
  if (!userData || !userData.role) {
    return false;
  }

  return userData.role.key === RoleTypesEnum.CLIENT;
};

/**
 * Optional: Checks if the user is either a Client OR a Distributor
 * (Useful if both share the "Customer Portal" view)
 */
export const isCustomerLoggedIn = (): boolean => {
  const userData = getDecryptedUserData();

  if (!userData || !userData.role) {
    return false;
  }

  return (
    userData.role.key === RoleTypesEnum.CLIENT ||
    userData.role.key === RoleTypesEnum.DISTRIBUTOR
  );
};

export const isAdminSubAdminLoggedIn = (): boolean => {
  const userData = getDecryptedUserData();

  if (!userData || !userData.role) {
    return false;
  }

  return (
    userData.role.key === RoleTypesEnum.ADMIN ||
    userData.role.key === RoleTypesEnum.SUB_ADMIN
  );
};

/**
 * Directly returns the role key string of the currently logged-in user.
 * Returns null if no user data or role key is found.
 */
export const getUserRole = (): string | null => {
  const userData = getDecryptedUserData();

  // Safety check to ensure role and key exist before returning
  if (!userData || !userData.role || !userData.role.key) {
    return null;
  }

  return userData.role.key;
};

/**
 * Returns the full decrypted name of the currently logged-in user.
 * Returns an empty string if no user data is found.
 */
export const getLoggedInUserName = (): string => {
  const userData = getDecryptedUserData();

  // Safety check for null or undefined user data
  if (!userData) {
    return "";
  }

  // Uses your existing helper to handle decryption and formatting
  return getDecryptedName(userData);
};

/**
 * Returns the unique ID (_id) of the currently logged-in user.
 * Returns null if no user data or ID is found.
 */
export const getLoggedInUserId = (): string | null => {
  const userData = getDecryptedUserData();

  // Safety check for null data or missing _id
  if (!userData || !userData._id) {
    return null;
  }

  return userData._id;
};

/**
 * Checks if any user is currently logged in.
 * Returns true if valid user data exists, false otherwise.
 */
export const isLoggedIn = (): boolean => {
  const userData = getDecryptedUserData();

  // Returns true if userData exists and has a valid ID
  return !!(userData && userData._id);
};

const PALLET_SETTINGS_KEY = "pallet_settings";
export const getPalletSetting = () => {
  try {
    const settings = localStorage.getItem(PALLET_SETTINGS_KEY);
    return settings
      ? JSON.parse(settings)
      : {
          selected3dView: true,
          showGoods: true,
          showLines: false,
        };
  } catch (error) {
    console.error("Error retrieving pallet settings:", error);
    return {
      selected3dView: true,
      showGoods: true,
      showLines: false,
    };
  }
};

export const setPalletSetting = (newSettings: any) => {
  try {
    const currentSettings = getPalletSetting();
    const updatedSettings = { ...currentSettings, ...newSettings };
    localStorage.setItem(PALLET_SETTINGS_KEY, JSON.stringify(updatedSettings));
  } catch (error) {
    console.error("Error saving pallet settings:", error);
  }
};
export const getPalletSettings = getPalletSetting;
